<!--
 * @Author: liushuang
 * @Date: 2023-02-07 20:19:35
 * @LastEditors: liushuang
 * @Description: 
 * @FilePath: \Ats-web\src\components\search\jobCategory.vue
-->
<template>
   <a-tree-select
    v-model:value="jobCategorySel"
    treeNodeFilterProp="title"
    style="width: 100%"
    tree-checkable
    show-search
    labelInValue
    :showArrow="true"
    placeholder="请选择"
    :dropdownMatchSelectWidth=false
    :filterTreeNode="filterTreeNode"
    :tree-data="treeData"
    :getPopupContainer="
                triggerNode => {
                  return triggerNode.parentNode
                }"
    @change="searchBtn"
    @click="setNodeBtn"
    @search="searchValue"
  >
    <template #title="{ title }">
      <template v-if="title.toLowerCase().indexOf(selVal.toLowerCase()) > -1 && selVal.length > 0">
        <span v-html="validater.strIndexOf(selVal, title)"></span>
      </template>
      <span v-else>{{ title }}</span>
    </template>
    <template #suffixIcon><svg t="1675939229923" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2927" xmlns:xlink="http://www.w3.org/1999/xlink" width="12" height="12"><path d="M761.923087 702.208894c2.19403 1.535821 4.241792 3.217911 6.143285 5.192539l243.391091 243.317956A43.149262 43.149262 0 0 1 981.033577 1024a42.78359 42.78359 0 0 1-30.350752-12.505973L707.364868 768.029802a41.686575 41.686575 0 0 1-5.119404-6.143285 429.664261 429.664261 0 1 1 59.677623-59.750757z m-332.176182 71.305984a343.731408 343.731408 0 1 0 0-687.462817 343.731408 343.731408 0 0 0 0 687.462817z" fill="#A2A5B4" p-id="2928"></path></svg></template>
  </a-tree-select>
</template>
<script>
import {sortBy} from 'lodash-es'
import { defineComponent, reactive, ref, toRefs, onMounted, nextTick } from 'vue';
import { message } from 'ant-design-vue';
import { validater } from "@/utils/validater.js"
import $ from 'jquery'
import { 
  getProfessionVategoryApi
 } from '@/api/comm'
export default defineComponent({
  props: {
    oldJobCategory: Array,
    selecNum:Number,
  },
  emits: ['searchJobTypehandle'],
  setup(props, {emit}) {
    const data = reactive({
      treeData: [],
      arrList: [],
      selVal: '',
    })
    onMounted(() => {
      getProfessionVategory();
    })
    const jobCategorySel = ref([]);
    jobCategorySel.value = props.oldJobCategory ? props.oldJobCategory : [];
    //获取职位类别集合
    const getProfessionVategory = (val) => {
      let params = {
        parentId: val
      }
      getProfessionVategoryApi(params).then(res => {
        if (res.success) {
          setTreeNode(res.data);          
        } else {
          message.warning(res.message);
        }
      })
    }
    //设置职位层级
    const setTreeNode = (arr) => {
      var result = [];   
			const itemMap = {};   
			for (var item of arr) {
        itemMap[item.id] = { ...item, children: [] ,
          title: item.name,
          value: item.id,
          checkable: item.hasNextLevel ? false : true
        }
        const id = item.id;
        const parentId = item.parentId;
        var treeItem = itemMap[id];
        treeItem = itemMap[id]
        if (parentId == 0) {
          result.push(treeItem);
          result = sortBy([...result],[function(o) { return o.sort; }]);
        } else {
          itemMap[parentId].children.push(treeItem)
          itemMap[parentId].children = sortBy([...itemMap[parentId].children],[function(o) { return o.sort; }]);
        }
			}
			data.treeData = result;
      if(jobCategorySel.value.length == props.selecNum) {
        getAllIds(data.treeData, jobCategorySel.value)
      }
    }
    //设置按钮
    const setNodeBtn = () => {
      nextTick(() => {
        $(".btn-tree-buttom").remove()
        if ($(".btn-tree-buttom").length == 0) {
          var div = $("<div class='btn-tree-buttom'><a type='primary' class='mainBtn' @click='handleButtonClick'>确 定</a></div>")
          $(".ant-select-tree-list").append(div);
        }
        $(".ant-select-tree-list").on("click", ".mainBtn", () => {
          $(".ant-select-selection-search-input").blur();
          data.selVal = '';
        })
      })
    }

    //递归遍历数组
    const getAllIds = (tree,value)=>{
      for (const i in tree) {
        tree[i].disabled = value.length ?!(value.findIndex(info =>  tree[i].value == info.value) > -1):false
        if (tree[i].children) {
          getAllIds(tree[i].children,value);
        }
      }
    }
    //选中值发生改变
    const searchBtn = (value) => {
      if( value.length <= props.selecNum ){
        emit('searchJobTypehandle', value)
        getAllIds(data.treeData,[])
      }
      if(value.length == props.selecNum){
        getAllIds(data.treeData,value)
      }
    }
    //输入的搜索内容
    const searchValue = (value) => {
      data.selVal = value;
      setNodeBtn();
    }
    return {
      ...toRefs(data),
      jobCategorySel,
      getProfessionVategory,
      setNodeBtn,
      searchBtn,
      searchValue,
      validater
    };
  },
});
</script>
<style scoped>
::v-deep .ant-select-tree .ant-select-tree-treenode {
  margin-right: 12px;
}
</style>